import { isEmpty } from "assets/scripts/utilities/helpers";

/**
 * Generates computed properties for form buttons with consistent defaults
 *
 * @param {Object} props - Component props containing button configurations
 * @returns {Object} Object containing computed properties for each button type
 */
export function useFormButtons(props) {
  const computedHeaderCta = computed(() => {
    if (!isEmpty(props.headerCta)) {
      return {
        fluid: false,
        ...props.headerCta,
      };
    }

    return {};
  });

  const computedPrimaryCta = computed(() => {
    if (
      props.primaryCta === undefined ||
      (props.primaryCta && !isEmpty(props.primaryCta))
    ) {
      return {
        color: "primary",
        fluid: false,
        label: "Submit",
        type: "submit",
        ...props.primaryCta,
      };
    }

    return {};
  });

  const computedSecondaryCta = computed(() => {
    if (
      props.secondaryCta === undefined ||
      (props.secondaryCta && !isEmpty(props.secondaryCta))
    ) {
      return {
        color: "primary",
        fluid: false,
        label: "Reset",
        outline: true,
        type: "reset",
        ...props.secondaryCta,
      };
    }

    return {};
  });

  const computedTernaryCta = computed(() => {
    if (!isEmpty(props.ternaryCta)) {
      return {
        fluid: false,
        ...props.ternaryCta,
      };
    }

    return {};
  });

  const computedQuaternaryCta = computed(() => {
    if (!isEmpty(props.quaternaryCta)) {
      return {
        fluid: false,
        color: "primary",
        outline: true,
        ...props.quaternaryCta,
      };
    }

    return {};
  });

  return {
    computedHeaderCta,
    computedPrimaryCta,
    computedSecondaryCta,
    computedTernaryCta,
    computedQuaternaryCta,
  };
}
